import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import './SportBanners.css';
import { SportBannersService } from './SportBanners.service';
import { BannerLoader } from '../../../../../shared/src/components/BannersCarousel/BannerLoader';
import { BannersCarousel } from '../../../../../shared/src/components/BannersCarousel/BannersCarousel';
import { BannerSlide } from '../../../../../shared/src/components/BannersCarousel/BannerSlide';
import { AsgAppContext, AsgDictionaryContext, AsgFwContext } from '../../../contexts';
import { useCollapseBanner } from '../hooks/collapse-banner.hook';

export const SportBanners = () => {
    // As per requirements
    const bannersToShowCount = 3;

    const [portal, setPortal] = useState(null);
    const [bannersToRender, setBannersToRender] = useState(null);
    const [bannersCount, setBannersCount] = useState(0);
    const [bannersCollapseTimerExpired, setBannersCollapseTimerExpired] = useState(false);
    const [bannersCollapseTimer, setBannersCollapseTimer] = useState(0);

    const Dictionary = useContext(AsgDictionaryContext);
    const AsgFW = useContext(AsgFwContext);
    const AsgApp = useContext(AsgAppContext);

    const { isMobile } = useSelector((state) => state.app);
    const { banners: { active, bannersList, placeholderBannerData } } = useSelector((state) => state.sport);

    // get and save target element for portal
    useEffect(() => {
        const portalElement = document.getElementById('asg-vertical-banners-portal');

        if (portalElement) {
            setPortal(portalElement);
        }
    }, []);

    useCollapseBanner(
        portal,
        bannersToRender,
        setBannersCollapseTimer,
        setBannersCollapseTimerExpired,
        bannersCollapseTimer,
    );

    useEffect(() => {
        const bannersCount = SportBannersService.getBannersCount(bannersList);
        // mapping to avoid object is not extensible error
        const bannersToShow = bannersCount ? bannersList.map((item) => ({ ...item })) : [];
        setBannersCount(bannersCount);
        if (bannersCount >= bannersToShowCount) {
            setBannersToRender(bannersToShow.slice(0, bannersToShowCount));
        } else if (placeholderBannerData?.active) {
            setBannersToRender(SportBannersService.getPlaceholderBanner(
                placeholderBannerData,
                isMobile,
            ));
        }
    }, [bannersList]);

    if (!active || !portal) {
        return null;
    }

    const isPlaceholderVisible = bannersCount < bannersToShowCount && placeholderBannerData?.active;

    const wrapperClasses = [
        'banners-wrapper',
        'banners-visible',
        'aspire-engage',
        'asg-vertical__sport-banners',
        bannersCollapseTimerExpired ? 'collapse-transition' : '',
    ];

    const carouselClasses = [
        'transition-opacity-out',
        'banners-visible',
        'aspire-engage',
        isPlaceholderVisible ? 'banners-carousel--placeholder-visible' : '',
    ];

    return ReactDOM.createPortal((
        <section className={wrapperClasses.join(' ')}>
            {/** Loaders */}
            {/* 1 loader for both Mobile and Desktop device types */}
            {!bannersToRender && <BannerLoader />}

            {/** Banners */}
            {isMobile && bannersToRender && <div id="banners-carousel" className={carouselClasses.join(' ')}>
                <BannersCarousel
                    bannersData={bannersToRender}
                    globals={{
                        Dictionary,
                        AsgFW,
                        AsgApp,
                    }}
                    usePnPBanners={false}
                />
            </div>}

            {!isMobile && bannersToRender && bannersToRender.map((bannerData, bannerIndex) => (
                <div
                    className="asg-vertical__sport-banner-item"
                    key={bannerIndex}
                >
                    <BannerSlide
                        bannerContent={bannerData}
                        globals={{
                            Dictionary,
                            AsgFW,
                            AsgApp,
                        }}
                        usePnPBanners={false}
                    />
                </div>
            ))}
        </section>
    ), portal);
};
